import store from '@/store'

export const ValidateCode = (result) => {
  if (!CheckLength(result)) {
    return null
  }
  const type = result[0]
  if (!CheckType(type)) {
    return null
  }
  const tableTypeString = result.substring(0, 1)
  const tableTypeNumber = GetTypeForTable(tableTypeString)
  if (tableTypeNumber === undefined) {
    return null
  }
  // Substrings
  const curve01String = result.substring(1, 3)
  const curve02String = result.substring(3, 5)
  const curve03String = result.substring(5, 7)
  const curve04String = result.substring(7, 9)
  const Pt0XString = result.substring(9, 11)
  const Pt0YString = result.substring(11, 13)
  const Pt1XString = result.substring(13, 15)
  const Pt1YString = result.substring(15, 17)
  const Pt2XString = result.substring(17, 19)
  const Pt2YString = result.substring(19, 21)
  const Pt0ForceString = result.substring(21, 23)
  const Pt1ForceString = result.substring(23, 25)
  const Pt2ForceString = result.substring(25, 27)
  // Parse
  const curve01Parsed = parseInt(curve01String)
  const curve02Parsed = parseInt(curve02String)
  const curve03Parsed = parseInt(curve03String)
  const curve04Parsed = parseInt(curve04String)
  const Pt0XParsed = parseInt(Pt0XString)
  const Pt0YParsed = parseInt(Pt0YString)
  const Pt1XParsed = parseInt(Pt1XString)
  const Pt1YParsed = parseInt(Pt1YString)
  const Pt2XParsed = parseInt(Pt2XString)
  const Pt2YParsed = parseInt(Pt2YString)
  const Pt0ForceParsed = parseInt(Pt0ForceString)
  const Pt1ForceParsed = parseInt(Pt1ForceString)
  const Pt2ForceParsed = parseInt(Pt2ForceString)
  if (!CheckInt(curve01Parsed) ||
      !CheckInt(curve02Parsed) ||
      !CheckInt(curve03Parsed) ||
      !CheckInt(curve04Parsed) ||
      !CheckInt(Pt0XParsed) ||
      !CheckInt(Pt0YParsed) ||
      !CheckInt(Pt1XParsed) ||
      !CheckInt(Pt1YParsed) ||
      !CheckInt(Pt2XParsed) ||
      !CheckInt(Pt2YParsed) ||
      !CheckInt(Pt0ForceParsed) ||
      !CheckInt(Pt1ForceParsed) ||
      !CheckInt(Pt2ForceParsed)) {
    return null
  }
  const remapCurve01 = curve01Parsed - 12
  const remapCurve02 = curve02Parsed - 12
  const remapCurve03 = curve03Parsed - 12
  const remapCurve04 = curve04Parsed - 12
  if (!CheckAngleRange(remapCurve01) || !CheckAngleRange(remapCurve02) || !CheckAngleRange(remapCurve03) || !CheckAngleRange(remapCurve04)) {
    return null
  }

  return {
    type: tableTypeNumber,
    rotations: [remapCurve01, remapCurve02, remapCurve03, remapCurve04],
    uvs: [Pt0XParsed / 100, Pt0YParsed / 100, Pt1XParsed / 100, Pt1YParsed / 100, Pt2XParsed / 100, Pt2YParsed / 100],
    forces: [Pt0ForceParsed / 100, Pt1ForceParsed / 100, Pt2ForceParsed / 100]
  }
}

function GetTypeForTable (s) {
  if (s === 'a' || s === 'A') {
    return 0
  }
  if (s === 'b' || s === 'B') {
    return 1
  }
  if (s === 'c' || s === 'C') {
    return 2
  }
  if (s === 'd' || s === 'D') {
    return 3
  }
  if (s === 'e' || s === 'E') {
    return 4
  }
  return undefined
}

function CheckLength (result) {
  return result.length === 27
}

function CheckType (type) {
  return type.match(/[a-zA-Z]/i)
}

function CheckInt (number) {
  return !isNaN(number) && (number >= 0 && number <= 99)
}

function CheckAngleRange (number) {
  return number >= -12 && number <= 12
}

export const ParseCode = () => {
  let s = ''
  const type = store.getters.table.id
  const crv1 = FormatCurveValue(store.getters.curve01)
  const crv2 = FormatCurveValue(store.getters.curve02)
  const crv3 = FormatCurveValue(store.getters.curve03)
  const crv4 = FormatCurveValue(store.getters.curve04)
  const pt1U = FormatUV(store.getters.u1)
  const pt1V = FormatUV(store.getters.v1)
  const pt2U = FormatUV(store.getters.u2)
  const pt2V = FormatUV(store.getters.v2)
  const pt3U = FormatUV(store.getters.u3)
  const pt3V = FormatUV(store.getters.v3)
  const f1 = FormatForce(store.getters.force01)
  const f2 = FormatForce(store.getters.force02)
  const f3 = FormatForce(store.getters.force03)
  s = type + crv1 + crv2 + crv3 + crv4 + pt1U + pt1V + pt2U + pt2V + pt3U + pt3V + f1 + f2 + f3
  return s
}

function FormatCurveValue (val) {
  return ('00' + ((parseInt(val) + 12)).toString()).slice(-2)
}

function FormatUV (val) {
  return ('00' + (Math.min(Math.floor(val * 100), 99)).toString()).slice(-2)
}

function FormatForce (val) {
  return ('00' + (Math.min(Math.floor(val * 100), 99)).toString()).slice(-2)
}
